import React from "react";
import "./cv.css";

export const CV = () => {
  return (
      <div className="portfolio-component-1">
            <h1 id="curriculum-vitae">Curriculum Vitae</h1>
            <div id="profile-img" />
            <div id="about-div">
                <h1 id="about">About</h1>
                <p id="about-content">Kishore Anand, an student of Btech CSE with specialisation in AI and Robotics at VIT Chennai. A calm and process-driven person with strong will and sheer determination. A quick learner and dedicated person with high hopes of doing something good for this society. Has the capability to provide optimal and unbiased solutions for any given situation at hand. And mainly an enthusiastic programmer with a really good knowledge about python, Full stack, C, C++, Ethical Hacking and Java.</p>
            </div>
      </div>
    );
};
    
    
export default CV;